import ExternalFilesContext from '@/components/FileAttachments/ExternalFilesContext';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import { type DatabaseExternalFile } from '@/lib/types';
import type React from 'react';
import { useContext } from 'react';
import useRubricsPortfolioApiEndpoint from '../../../useRubricsPortfolioApiEndpoint';

type ProofExternalFilesContextProviderProps = {
  levelId: number;
  children: React.ReactNode;
};

const ProofExternalFilesContextProvider = ({
  levelId,
  children,
}: ProofExternalFilesContextProviderProps) => {
  const rubricsPortfolioApiEndpoint = useRubricsPortfolioApiEndpoint();

  const [portfolio, setPortfolio] = useContext(RubricsPortfolioContext);
  const proofExternalFiles = Object.values(
    portfolio.proofExternalFiles?.[levelId] ?? {},
  );

  return (
    <ExternalFilesContext.Provider
      value={{
        externalFiles: proofExternalFiles,
        externalFilesExternalIds: proofExternalFiles.map(
          proofExternalFile => proofExternalFile.externalFile.externalId,
        ),
        externalFilesEndpoint: `${rubricsPortfolioApiEndpoint}/proof/${levelId}/external-files`,
        addExternalFileToLocalState: (
          externalFile: DatabaseExternalFile,
        ): void => {
          setPortfolio(portfolio => {
            if (typeof portfolio.proofExternalFiles![levelId] === 'undefined') {
              portfolio.proofExternalFiles![levelId] = {};
            }

            portfolio.proofExternalFiles![levelId][externalFile.id] =
              externalFile;
          });
        },
        removeExternalFileFromLocalState: (
          externalFile: DatabaseExternalFile,
        ): void => {
          setPortfolio(portfolio => {
            delete portfolio.proofExternalFiles![levelId][externalFile.id];
          });
        },
      }}
    >
      {children}
    </ExternalFilesContext.Provider>
  );
};

export default ProofExternalFilesContextProvider;
